<!-- Main Body Starts -->
<div class="layout-px-spacing">
  <div class="row" style="width: 100%">
    <!-- QUICK CATEGORIES -->
    <div class="row quick-categories-container">
      <div class="security-breaches">
        <a class="widget quick-category" style="cursor: default">
          <div class="quick-category-head">
            <span class="rounded-circle">
              <i class="icon dashboard-breaches" style="font-size: 30px"></i>
            </span>
            <span class="rounded-circle d-flex align-items-center" style="gap:6px">
              <button
                class="btn btn-link p-0 alert-config-btn"
                [class.alert-config-btn--active]="externalDeliveryKpiActive"
                (click)="openExternalDeliveryConfig($event)"
                ngbTooltip="Configurar filtros de envíos"
              >
                <i class="las la-sliders-h" style="font-size:18px"></i>
              </button>
              <div
                data-tooltip="securityBreaches"
                class="tooltip-container"
                (click)="toggleTooltip('securityBreaches')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['securityBreaches']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content"
                  >{{ 'home.securityBreachesTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div class="quick-category-content">
            <div
              *ngIf="loadingSecurityBreachesCount"
              style="margin-bottom: 0.8rem"
              class="spinner-border"
              role="status"
            >
              <span class="sr-only"></span>
            </div>
            <h3
              *ngIf="!loadingSecurityBreachesCount"
              (click)="navigateInformes('dlp', 'externalDelivery')"
              style="cursor: pointer"
            >
              {{ securityBreachesCount || 0 }}
            </h3>
            <p
              class="font-17 text-primary mb-0"
              (click)="navigateInformes('dlp', 'externalDelivery')"
              style="cursor: pointer"
            >
              {{ 'home.securityBreaches' | translate }}
            </p>
          </div>
        </a>
      </div>
      <div class="labeled-documents">
        <a class="widget quick-category" style="cursor: default">
          <div class="quick-category-head">
            <span class="rounded-circle">
              <i class="icon dashboard-docs" style="font-size: 30px"></i>
            </span>
            <span class="rounded-circle">
              <div
                data-tooltip="labeledDocuments"
                class="tooltip-container"
                (click)="toggleTooltip('labeledDocuments')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['labeledDocuments']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content"
                  >{{ 'home.labeledDocumentsTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div class="quick-category-content">
            <div
              *ngIf="loadingDocumentLabeledCount"
              style="margin-bottom: 0.8rem"
              class="spinner-border"
              role="status"
            >
              <span class="sr-only"></span>
            </div>
            <h3
              *ngIf="!loadingDocumentLabeledCount"
              (click)="navigateInformes('irm')"
              style="cursor: pointer"
            >
              {{ documentLabeledCount || 0 }}
            </h3>
            <p
              class="font-17 mb-0"
              (click)="navigateInformes('irm')"
              style="cursor: pointer; color: #2f44b2"
            >
              {{ 'home.labeledDocuments' | translate }}
            </p>
          </div>
        </a>
      </div>
      <div class="identified-alerts">
        <a class="widget quick-category" style="cursor: default">
          <div class="quick-category-head">
            <span class="rounded-circle">
              <i class="icon dashboard-alertas" style="font-size: 20px"></i>
            </span>
            <span class="rounded-circle d-flex align-items-center" style="gap:6px">
              <button
                class="btn btn-link p-0 alert-config-btn"
                [class.alert-config-btn--active]="alertKpiActive"
                (click)="openAlertConfig($event)"
                ngbTooltip="Configurar filtros de alerta"
                placement="top"
                [openDelay]="300"
              >
                <i class="las la-sliders-h" style="font-size:18px"></i>
              </button>
              <div
                data-tooltip="identifiedAlerts"
                class="tooltip-container"
                (click)="toggleTooltip('identifiedAlerts')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['identifiedAlerts']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content"
                  >{{ 'home.identifiedAlertsTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div class="quick-category-content">
            <div
              *ngIf="loadingIdentifiedAlertsCount"
              style="margin-bottom: 0.8rem"
              class="spinner-border"
              role="status"
            >
              <span class="sr-only"></span>
            </div>
            <h3
              *ngIf="!loadingIdentifiedAlertsCount"
              (click)="navigateIdentifiedAlerts()"
              style="cursor: pointer"
            >
              {{ identifiedAlertsCount || 0 }}
            </h3>
            <p
              class="font-17 text-warning mb-0"
              (click)="navigateIdentifiedAlerts()"
              style="cursor: pointer"
            >
              {{ 'home.identifiedAlerts' | translate }}
            </p>
          </div>
        </a>
      </div>
      <div class="users-tagging">
        <a class="widget quick-category" style="cursor: default">
          <div class="quick-category-head">
            <span class="rounded-circle">
              <i class="icon dashboard-usuarios" style="font-size: 30px"></i>
            </span>
            <span class="rounded-circle d-flex align-items-center" style="gap:6px">
              <button
                class="btn btn-link p-0 alert-config-btn"
                [class.alert-config-btn--active]="taggingKpiActive"
                (click)="openTaggingKpiConfig($event)"
                ngbTooltip="Configurar tipos de etiquetado"
                placement="top"
                [openDelay]="300"
              >
                <i class="las la-sliders-h" style="font-size:18px"></i>
              </button>
              <div
                data-tooltip="usersTagging"
                class="tooltip-container"
                (click)="toggleTooltip('usersTagging')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['usersTagging']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content"
                  >{{ 'home.usersTaggingTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div class="quick-category-content">
            <div
              *ngIf="loadingTaggingUsersCount"
              style="margin-bottom: 0.8rem"
              class="spinner-border"
              role="status"
            >
              <span class="sr-only"></span>
            </div>
            <h3
              *ngIf="!loadingTaggingUsersCount"
              (click)="navigateInformes('irm')"
              style="cursor: pointer"
            >
              {{ taggingUsersCount || 0 }}
            </h3>
            <p
              class="font-17 mb-0"
              (click)="navigateInformes('irm')"
              style="cursor: pointer; color: #5c1ac3"
            >
              {{ 'home.usersTagging' | translate }}
            </p>
            <span *ngIf="isExceeded" style="color: red" class="text-center">{{
              'home.contractedLicenseExceeded' | translate
            }}</span>
          </div>
        </a>
      </div>
      <div class="copilot-interactions">
        <a class="widget quick-category" style="cursor: default">
          <div class="quick-category-head">
            <span class="rounded-circle">
              <i class="icon dashboard-breaches" style="font-size: 30px"></i>
            </span>
            <span class="rounded-circle">
              <div
                data-tooltip="copilotInteractions"
                class="tooltip-container"
                (click)="toggleTooltip('copilotInteractions')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['copilotInteractions']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content"
                  >{{ 'home.copilotInteractionsTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div class="quick-category-content">
            <div
              *ngIf="loadingCopilotInteractionsCount"
              style="margin-bottom: 0.8rem"
              class="spinner-border"
              role="status"
            >
              <span class="sr-only"></span>
            </div>
            <h3
              *ngIf="!loadingCopilotInteractionsCount"
              (click)="navigateInformes('ia')"
              style="cursor: pointer"
            >
              {{ copilotInteractionsCount || 0 }}
            </h3>
            <p
              class="font-17 mb-0"
              (click)="navigateInformes('ia')"
              style="cursor: pointer; color: #5c1ac3"
            >
              {{ 'home.copilotInteractions' | translate }}
            </p>
            <span *ngIf="isExceeded" style="color: red" class="text-center">{{
              'home.contractedLicenseExceeded' | translate
            }}</span>
          </div>
        </a>
      </div>
    </div>
    <!-- CHARTS -->
    <div class="charts-container">
      <div class="chart-one">
        <div class="widget widget-chart-one">
          <div class="widget-heading">
            <h5 class="">{{ 'home.actionAlertsSentitiveData' | translate }}</h5>
            <span class="rounded-circle">
              <div
                data-tooltip="actionAlertsSentitiveData"
                class="tooltip-container"
                (click)="toggleTooltip('actionAlertsSentitiveData')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['actionAlertsSentitiveData']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content bottom"
                  >{{
                    'home.actionAlertsSentitiveDataTooltip' | translate
                  }}</span
                >
              </div>
            </span>
          </div>
          <div class="widget-content" style="min-height: 320px">
            <div class="tabs tab-content">
              <div id="content_1" class="tabcontent">
                <div
                  class="center"
                  style="min-height: 320px"
                  *ngIf="isLoading1"
                >
                  <div class="spinner-border" role="status">
                    <span class="sr-only">{{
                      'home.loading' | translate
                    }}</span>
                  </div>
                </div>
                <div id="transactionsMonthly"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chart-two">
        <div
          class="widget widget-table-one"
          style="height: fit-content; min-height: 435px"
        >
          <div
            class="widget-heading d-flex justify-content-between align-items-center"
          >
            <h5 class="">{{ 'home.alertsHighSentitiveData' | translate }}</h5>
            <span class="rounded-circle">
              <div
                data-tooltip="alertsHighSentitiveData"
                class="tooltip-container"
                (click)="toggleTooltip('alertsHighSentitiveData')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['alertsHighSentitiveData']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content bottom"
                  style="width: 29rem"
                  >{{ 'home.alertsHighSentitiveDataTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div
            class="widget-content"
            style="min-height: 15rem; height: 87% !important"
          >
            <div class="center" style="min-height: 15rem" *ngIf="isLoading4">
              <div class="spinner-border" role="status">
                <span class="sr-only">{{ 'home.loading' | translate }}</span>
              </div>
            </div>
            <div *ngIf="!isLoading4 && !chart4Empty">
              <div
                class="weekly-bestsellers"
                style="cursor: default"
                *ngFor="let alert of sensitiveInformationAlerts"
              >
                <div class="t-item">
                  <div class="t-company-name" style="width: 100%">
                    <div class="t-name" style="width: 100%">
                      <p class="meta-date" style="color: #607eff">
                        {{ alert.sensitiveType || '' }}
                      </p>
                      <h4 style="overflow-wrap: break-word">
                        {{ alert.user || '' }}
                      </h4>
                      <p style="overflow-wrap: break-word" class="meta-date">
                        {{ (alert.file | cutString : 50) || '' }}
                      </p>
                    </div>
                  </div>
                  <div class="t-rate rate-inc">
                    <p>
                      <span>{{ alert.count || 0 }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf="chart4Empty"
              id="noData"
              style="height: 15rem; display: grid; place-content: center"
            >
              {{ 'noData' | translate }}
            </div>
            <a
              *ngIf="!chart4Empty && !isLoading4"
              class="btn btn-block btn-primary"
              routerLink="/home/informes/dlp"
              style="margin-top: 15px"
              >{{ 'home.viewAll' | translate }}</a
            >
          </div>
        </div>
      </div>
      <div class="chart-three">
        <div class="widget dashboard-table" style="height: 445px">
          <div class="widget-heading mb-1">
            <h5 class="">{{ 'home.userLabeling' | translate }}</h5>
            <div class="d-flex align-items-center">
              <span class="rounded-circle">
                <div
                  data-tooltip="userLabeling"
                  class="tooltip-container"
                  (click)="toggleTooltip('userLabeling')"
                >
                  <i
                    class="icon dashboard-tooltip-info"
                    style="font-size: 30px"
                  ></i>
                  <span
                    *ngIf="tooltipsVisible['userLabeling']"
                    (click)="$event.stopPropagation()"
                    class="tooltip-content"
                    >{{ 'home.userLabelingTooltip' | translate }}</span
                  >
                </div>
              </span>
            </div>
          </div>
          <div class="widget-content h-100">
            <div
              class="table-responsive"
              style="
                height: 90%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <table *ngIf="!chart3Empty" class="table table-hover">
                <thead>
                  <tr>
                    <th>
                      <div class="th-content">
                        {{ 'home.user' | translate }}
                      </div>
                    </th>
                    <th>
                      <div class="th-content">
                        {{ 'home.labeled' | translate }}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody *ngIf="isLoading3">
                  <tr *ngFor="let i of [1, 2, 3, 4, 5]">
                    <td><div class="skeleton skeleton-row"></div></td>
                    <td><div class="skeleton skeleton-row"></div></td>
                  </tr>
                </tbody>
                <tbody *ngIf="!isLoading3 && !chart3Empty">
                  <tr *ngFor="let user of topDeniedUsers; let i = index">
                    <td>
                      <div class="d-flex align-items-center" style="gap: 6px">
                        <img *ngIf="i === 0 && showChart5" src="assets/img/trophy.png" style="width: 18px; height: 18px; flex-shrink: 0" />
                        <p class="mb-0">{{ user.name || '' }}</p>
                      </div>
                    </td>
                    <td>
                      <span class="text-warning">{{ user.count || 0 }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                *ngIf="chart3Empty"
                id="noData"
                style="height: 4rem; display: grid; place-content: center"
              >
                {{ 'noData' | translate }}
              </div>
              <p
                *ngIf="!isLoading3 && !chart3Empty"
                class="font-13 text-center mt-2 mb-1 text-muted"
              >
                <a class="text-primary" routerLink="/home/informes/irm">{{
                  'home.clickHere' | translate
                }}</a>
                {{ 'home.toSeeFullList' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="chart-four">
        <div class="widget widget-chart-two">
          <div
            class="widget-heading d-flex justify-content-between align-items-center"
          >
            <h5 class="">{{ 'home.documentLabeling' | translate }}</h5>
            <span class="rounded-circle">
              <div
                data-tooltip="documentLabeling"
                class="tooltip-container"
                (click)="toggleTooltip('documentLabeling')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['documentLabeling']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content bottom"
                  >{{ 'home.documentLabelingTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div
            class="widget-content"
            style="min-height: 340px; padding: 0 !important"
          >
            <div class="center" style="min-height: 340px" *ngIf="isLoading2">
              <div class="spinner-border" role="status">
                <span class="sr-only">{{ 'home.loading' | translate }}</span>
              </div>
            </div>
            <div id="orderStatus" class=""></div>
          </div>
        </div>
      </div>
      <div class="chart-six">
        <div class="widget widget-chart-one">
          <div class="widget-heading">
            <h5 class="">{{ 'home.topLabelsByDept' | translate }}</h5>
            <span class="rounded-circle">
              <div
                data-tooltip="topLabelsByDeptTooltip"
                class="tooltip-container"
                (click)="toggleTooltip('topLabelsByDeptTooltip')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['topLabelsByDeptTooltip']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content bottom"
                  >{{ 'home.topLabelsByDeptTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div class="widget-content" style="min-height: 350px">
            <div class="tabs tab-content">
              <div id="content_1" class="tabcontent">
                <div
                  class="center"
                  style="min-height: 350px"
                  *ngIf="isLoading6"
                >
                  <div class="spinner-border" role="status">
                    <span class="sr-only">{{
                      'home.loading' | translate
                    }}</span>
                  </div>
                </div>
                <div id="labelsByDept"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-seven">
        <div class="widget widget-three">
          <div
            class="widget-heading d-flex justify-content-between align-items-center"
          >
            <h5 class="">
              {{ 'home.documentLabelingPerDepartment' | translate }}
            </h5>
            <span class="rounded-circle">
              <div
                data-tooltip="documentLabelingPerDepartment"
                class="tooltip-container"
                (click)="toggleTooltip('documentLabelingPerDepartment')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['documentLabelingPerDepartment']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content bottom"
                  >{{
                    'home.documentLabelingPerDepartmentTooltip' | translate
                  }}</span
                >
              </div>
            </span>
          </div>
          <div class="widget-content" style="min-height: 350px">
            <div class="customer-issues">
              <div class="center" style="min-height: 350px" *ngIf="isLoading5">
                <div class="spinner-border" role="status">
                  <span class="sr-only">{{ 'home.loading' | translate }}</span>
                </div>
              </div>
              <div *ngIf="!isLoading5 && !chart7Empty">
                <div
                  *ngFor="let department of departamentLabel; let i = index"
                  class="customer-issue-list"
                >
                  <div class="customer-issue-details">
                    <div class="customer-issues-info">
                      <h6
                        class="mb-2 font-12"
                        [ngClass]="getIssueClass(department.department)"
                      >
                        {{ department.department }}
                      </h6>
                      <p class="issues-count mb-2 font-12">
                        {{ department.count || 0 }}
                      </p>
                    </div>
                    <div class="customer-issues-stats">
                      <div class="progress">
                        <div
                          class="progress-bar dynamic-color-{{
                            i
                          }} position-relative"
                          [ngStyle]="{
                            width: calculateWidth(department.count, i)
                          }"
                          [ngClass]="getProgressBarClass(i)"
                        >
                          <span [ngClass]="getSpanClass(i)"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                *ngIf="chart7Empty && !isLoading5"
                id="noData"
                style="
                  width: 100%;
                  height: 350px;
                  display: grid;
                  place-content: center;
                "
              >
                {{ 'noData' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="charts-ia-trio">

        <div class="chart-eight">
          <div class="widget dashboard-table chart-ia-card">
            <div class="widget-heading mb-1">
              <h5 class="" style="font-size: 16px">{{ 'home.getTopCopilotUsers' | translate }}</h5>
              <span class="rounded-circle">
                <div
                  data-tooltip="getTopCopilotUsers"
                  class="tooltip-container"
                  (click)="toggleTooltip('getTopCopilotUsers')"
                >
                  <i
                    class="icon dashboard-tooltip-info"
                    style="font-size: 30px"
                  ></i>
                  <span
                    *ngIf="tooltipsVisible['getTopCopilotUsers']"
                    (click)="$event.stopPropagation()"
                    class="tooltip-content"
                    >{{ 'home.getTopCopilotUsersTooltip' | translate }}</span
                  >
                </div>
              </span>
            </div>
            <div class="widget-content">
              <table *ngIf="!chart8Empty" class="table table-hover mb-0" style="font-size: 11px">
                <thead>
                  <tr>
                    <th>
                      <div class="th-content">{{ 'home.user' | translate }}</div>
                    </th>
                    <th>
                      <div class="th-content">{{ 'home.interactions' | translate }}</div>
                    </th>
                  </tr>
                </thead>
                <tbody *ngIf="isLoading8">
                  <tr *ngFor="let i of [1, 2, 3, 4, 5]">
                    <td><div class="skeleton skeleton-row"></div></td>
                    <td><div class="skeleton skeleton-row"></div></td>
                  </tr>
                </tbody>
                <tbody *ngIf="!isLoading8 && !chart8Empty">
                  <tr *ngFor="let user of getTopCopilotUsers">
                    <td>
                      <p class="mb-0" style="font-size: 11px; word-break: break-all">{{ user.user || '' }}</p>
                    </td>
                    <td>
                      <span class="text-warning">{{ user.count || 0 }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                *ngIf="chart8Empty"
                style="height: 4rem; display: grid; place-content: center"
              >
                {{ 'noData' | translate }}
              </div>
              <p
                *ngIf="!isLoading8 && !chart8Empty"
                class="font-13 text-center mt-3 mb-0 text-muted"
              >
                <a class="text-primary" routerLink="/home/informes/ia">{{
                  'home.clickHere' | translate
                }}</a>
                {{ 'home.toSeeFullList' | translate }}
              </p>
            </div>
          </div>
        </div>

        <div class="chart-nine">
          <div class="widget widget-chart-two chart-ia-card">
            <div
              class="widget-heading d-flex justify-content-between align-items-center"
            >
              <h5 class="" style="font-size: 16px">
                {{ 'home.topCopilotInteractionsByDepartment' | translate }}
              </h5>
              <span class="rounded-circle">
                <div
                  data-tooltip="topCopilotInteractionsByDepartment"
                  class="tooltip-container"
                  (click)="toggleTooltip('topCopilotInteractionsByDepartment')"
                >
                  <i
                    class="icon dashboard-tooltip-info"
                    style="font-size: 30px"
                  ></i>
                  <span
                    *ngIf="tooltipsVisible['topCopilotInteractionsByDepartment']"
                    (click)="$event.stopPropagation()"
                    class="tooltip-content bottom"
                    >{{
                      'home.topCopilotInteractionsByDepartmentTooltip' | translate
                    }}</span
                  >
                </div>
              </span>
            </div>
            <div class="widget-content" style="padding: 0 !important">
              <div class="center" style="height: 300px" *ngIf="isLoading9">
                <div class="spinner-border" role="status">
                  <span class="sr-only">{{ 'home.loading' | translate }}</span>
                </div>
              </div>
              <div id="topCopilotInteractionsByDepartment"></div>
            </div>
          </div>
        </div>

        <div class="chart-ten">
          <div class="widget widget-chart-two chart-ia-card">
            <div
              class="widget-heading d-flex justify-content-between align-items-center"
            >
              <h5 class="">{{ 'home.aiInteractionsByWorkload' | translate }}</h5>
              <span class="rounded-circle">
                <div
                  data-tooltip="aiInteractionsByWorkload"
                  class="tooltip-container"
                  (click)="toggleTooltip('aiInteractionsByWorkload')"
                >
                  <i
                    class="icon dashboard-tooltip-info"
                    style="font-size: 30px"
                  ></i>
                  <span
                    *ngIf="tooltipsVisible['aiInteractionsByWorkload']"
                    (click)="$event.stopPropagation()"
                    class="tooltip-content bottom"
                    >{{ 'home.aiInteractionsByWorkloadTooltip' | translate }}</span
                  >
                </div>
              </span>
            </div>
            <div class="widget-content" style="padding: 0 !important">
              <div class="center" style="height: 300px" *ngIf="isLoading10">
                <div class="spinner-border" role="status">
                  <span class="sr-only">{{ 'home.loading' | translate }}</span>
                </div>
              </div>
              <div
                *ngIf="!isLoading10 && chart10Empty"
                style="height: 300px; display: grid; place-content: center"
              >
                {{ 'noData' | translate }}
              </div>
              <div id="aiInteractionsByWorkload"></div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- Main Body Ends -->
  <footer *ngIf="showINCIBEFooter" class="incibe-footer">
    <img src="assets/img/BandaLogos_INCIBE_es.png" alt="Logo INCIBE" />
  </footer>
</div>
